import $3TfBJ$intlcolorarAEmjs from "../intl/color/ar-AE.mjs";
import $3TfBJ$intlcolorbgBGmjs from "../intl/color/bg-BG.mjs";
import $3TfBJ$intlcolorcsCZmjs from "../intl/color/cs-CZ.mjs";
import $3TfBJ$intlcolordaDKmjs from "../intl/color/da-DK.mjs";
import $3TfBJ$intlcolordeDEmjs from "../intl/color/de-DE.mjs";
import $3TfBJ$intlcolorelGRmjs from "../intl/color/el-GR.mjs";
import $3TfBJ$intlcolorenUSmjs from "../intl/color/en-US.mjs";
import $3TfBJ$intlcoloresESmjs from "../intl/color/es-ES.mjs";
import $3TfBJ$intlcoloretEEmjs from "../intl/color/et-EE.mjs";
import $3TfBJ$intlcolorfiFImjs from "../intl/color/fi-FI.mjs";
import $3TfBJ$intlcolorfrFRmjs from "../intl/color/fr-FR.mjs";
import $3TfBJ$intlcolorheILmjs from "../intl/color/he-IL.mjs";
import $3TfBJ$intlcolorhrHRmjs from "../intl/color/hr-HR.mjs";
import $3TfBJ$intlcolorhuHUmjs from "../intl/color/hu-HU.mjs";
import $3TfBJ$intlcoloritITmjs from "../intl/color/it-IT.mjs";
import $3TfBJ$intlcolorjaJPmjs from "../intl/color/ja-JP.mjs";
import $3TfBJ$intlcolorkoKRmjs from "../intl/color/ko-KR.mjs";
import $3TfBJ$intlcolorltLTmjs from "../intl/color/lt-LT.mjs";
import $3TfBJ$intlcolorlvLVmjs from "../intl/color/lv-LV.mjs";
import $3TfBJ$intlcolornbNOmjs from "../intl/color/nb-NO.mjs";
import $3TfBJ$intlcolornlNLmjs from "../intl/color/nl-NL.mjs";
import $3TfBJ$intlcolorplPLmjs from "../intl/color/pl-PL.mjs";
import $3TfBJ$intlcolorptBRmjs from "../intl/color/pt-BR.mjs";
import $3TfBJ$intlcolorptPTmjs from "../intl/color/pt-PT.mjs";
import $3TfBJ$intlcolorroROmjs from "../intl/color/ro-RO.mjs";
import $3TfBJ$intlcolorruRUmjs from "../intl/color/ru-RU.mjs";
import $3TfBJ$intlcolorskSKmjs from "../intl/color/sk-SK.mjs";
import $3TfBJ$intlcolorslSImjs from "../intl/color/sl-SI.mjs";
import $3TfBJ$intlcolorsrSPmjs from "../intl/color/sr-SP.mjs";
import $3TfBJ$intlcolorsvSEmjs from "../intl/color/sv-SE.mjs";
import $3TfBJ$intlcolortrTRmjs from "../intl/color/tr-TR.mjs";
import $3TfBJ$intlcolorukUAmjs from "../intl/color/uk-UA.mjs";
import $3TfBJ$intlcolorzhCNmjs from "../intl/color/zh-CN.mjs";
import $3TfBJ$intlcolorzhTWmjs from "../intl/color/zh-TW.mjs";

var $257573b61dd5f5f0$exports = {};


































$257573b61dd5f5f0$exports = {
    "ar-AE": $3TfBJ$intlcolorarAEmjs,
    "bg-BG": $3TfBJ$intlcolorbgBGmjs,
    "cs-CZ": $3TfBJ$intlcolorcsCZmjs,
    "da-DK": $3TfBJ$intlcolordaDKmjs,
    "de-DE": $3TfBJ$intlcolordeDEmjs,
    "el-GR": $3TfBJ$intlcolorelGRmjs,
    "en-US": $3TfBJ$intlcolorenUSmjs,
    "es-ES": $3TfBJ$intlcoloresESmjs,
    "et-EE": $3TfBJ$intlcoloretEEmjs,
    "fi-FI": $3TfBJ$intlcolorfiFImjs,
    "fr-FR": $3TfBJ$intlcolorfrFRmjs,
    "he-IL": $3TfBJ$intlcolorheILmjs,
    "hr-HR": $3TfBJ$intlcolorhrHRmjs,
    "hu-HU": $3TfBJ$intlcolorhuHUmjs,
    "it-IT": $3TfBJ$intlcoloritITmjs,
    "ja-JP": $3TfBJ$intlcolorjaJPmjs,
    "ko-KR": $3TfBJ$intlcolorkoKRmjs,
    "lt-LT": $3TfBJ$intlcolorltLTmjs,
    "lv-LV": $3TfBJ$intlcolorlvLVmjs,
    "nb-NO": $3TfBJ$intlcolornbNOmjs,
    "nl-NL": $3TfBJ$intlcolornlNLmjs,
    "pl-PL": $3TfBJ$intlcolorplPLmjs,
    "pt-BR": $3TfBJ$intlcolorptBRmjs,
    "pt-PT": $3TfBJ$intlcolorptPTmjs,
    "ro-RO": $3TfBJ$intlcolorroROmjs,
    "ru-RU": $3TfBJ$intlcolorruRUmjs,
    "sk-SK": $3TfBJ$intlcolorskSKmjs,
    "sl-SI": $3TfBJ$intlcolorslSImjs,
    "sr-SP": $3TfBJ$intlcolorsrSPmjs,
    "sv-SE": $3TfBJ$intlcolorsvSEmjs,
    "tr-TR": $3TfBJ$intlcolortrTRmjs,
    "uk-UA": $3TfBJ$intlcolorukUAmjs,
    "zh-CN": $3TfBJ$intlcolorzhCNmjs,
    "zh-TW": $3TfBJ$intlcolorzhTWmjs
};


export {$257573b61dd5f5f0$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
